import React from 'react';
import AccordionBlock from '../Blocks/AccordionBlock';
import BannerBlock from '../Blocks/BannerBlock/BannerBlock';
import BannerSliderBlock from '../Blocks/BannerSliderBlock/BannerSliderBlock';
import BrandsBlock from '../Blocks/BrandsBlock/BrandsBlock';
import FaqAccordion from '../Blocks/FaqAccordion';
import LinkBlock from '../Blocks/LinkBlock/LinkBlock';
import LinkListBlock from '../Blocks/LinkListBlock/LinkListBlock';
import MegaMenuBannerBlock from '../Blocks/MegaMenuBannerBlock/MegaMenuBannerBlock';
import ProductBlockNoSlider from '../Blocks/ProductBlockNoSlider';
import ProductSlider from '../Blocks/ProductSlider';
import ProductsAndBannerBlock from '../Blocks/ProductsAndBannerBlock';
import RichTextBlock from '../Blocks/RichTextBlock';
import UspBlock from '../Blocks/UspBlock';
import ActiveFilterChips from '../Components/ActiveFilterChips/ActiveFilterChips';
import BuyButton from '../Components/BuyButton/BuyButton';
import CategoryHeaderText from '../Components/Category.HeaderText';
import CategoryNavigation from '../Components/CategoryNavigation/CategoryNavigation';
import Checkout from '../Components/Checkout/Checkout';
import EditorString from '../Components/EditorString/EditorString';
import FavoriteButton from '../Components/FavoriteButton/FavoriteButton';
import FilterBar from '../Components/FilterBar/FilterBar';
import Footer from '../Components/Footer/Footer';
import LoginModal from '../Components/Login/LoginModal';
import LoginModalTrigger from '../Components/Login/LoginModalTrigger';
import LoginPage from '../Components/Login/LoginPage';
import MiniCart from '../Components/MiniCart/MiniCart';
import MiniCartButton from '../Components/MiniCart/MiniCartButton';
import MyPagesContainer from '../Components/MyPages/MyPagesContainer';
import Navigation from '../Components/Navigation/Navigation';
import NavigationMobile from '../Components/Navigation/NavigationMobile';
import NavigationMobileTrigger from '../Components/Navigation/NavigationMobileTrigger';
import OrderConfirmation from '../Components/OrderConfirmation/OrderConfirmation';
import Overlay from '../Components/Overlay';
import ProductFiltering from '../Components/ProductFiltering/ProductFiltering';
import ProductListHeaderText from '../Components/ProductList.HeaderText';
import ProductListing from '../Components/ProductListing/ProductListing';
import ProductListingTitle from '../Components/ProductListing/ProductListing.Title';
import ProductPageImageSlider from '../Components/ProductPageImageSlider/ProductPage.ImageSlider';
import ProductPagePrice from '../Components/ProductPagePrice/ProductPage.Price';
import ProductTabsContainer from '../Components/ProductPageTabs/ProductTabsContainer';
import ProductTabsContainerMobile from '../Components/ProductPageTabs/ProductTabsContainerMobile';
import ProductPageUsps from '../Components/ProductPageUsps/ProductPageUsps';
import ProductPageVariantIdentifier from '../Components/ProductPageVariantIdentifier/ProductPageVariantIdentifier';
import ProductPageVariantList from '../Components/ProductPageVariantList/ProductPage.VariantList';
import ProductSorting from '../Components/ProductSorting/ProductSorting';
import QuickSearch from '../Components/QuickSearch/QuickSearch';
import RegisterPage from '../Components/Register/RegisterPage';
import ResponsiveImage from '../Components/ResponsiveImage/ResponsiveImage';
import ScrollToElementButton from '../Components/ScrollToElementButton/ScrollToElementButton';
import SearchNavigation from '../Components/SearchResult/SearchNavigation';
import SearchResult from '../Components/SearchResult/SearchResult';
import SizeGuideContainer from '../Components/SizeGuide/SizeGuideContainer';
import StockStatus from '../Components/StockStatus/StockStatus';
import SubNavigationContainer from '../Components/SubNavigationContainer/SubNavigationContainer';
import Test from '../Components/Test';
import TestContainerForReact from '../Components/TestContainerForReact';
import TopMessage from '../Components/TopMessage/TopMessage';
import VariantMultiPickerDropdown from '../Components/VariantPicker/VariantMultiPicker.Dropdown';
import VariantPickerButtons from '../Components/VariantPicker/VariantPicker.Buttons';
import VariantPickerDropdown from '../Components/VariantPicker/VariantPicker.Dropdown';
import VariantSelectBuyButtonContainer from '../Components/VariantSelectBuyButton/VariantSelectBuyButtonContainer';
import WishList from '../Components/WishList/WishList';
import WishListButton from '../Components/WishList/WishListButton';
import { GLOBAL_STYLING_COMPONENT_NAME } from '../constants';
import { GlobalStyle } from '../styling/global.styled';
import ContentPage from '../styling/razor/pages/content-page';
import NewsList from '../styling/razor/pages/news-list';
import renderWrapper from './render-wrapper';
import { UspSign } from "../Components/Footer/FooterSign";
import QuickSearchLinkMobile from "../Components/MobileFooterMenu/QuickSearchLinkMobile";
import LoginIconLink from '../Components/Login/ui/LoginIconLink';
import CustomerServiceLink from '../Components/CustomerService/CustomerServiceLink';
import LoginIconLinkMobile from '../Components/MobileFooterMenu/LoginIconLinkMobile';
import LoginModalTriggerMobile from '../Components/MobileFooterMenu/LoginModalTriggerMobile';
import MiniCartButtonMobile from '../Components/MobileFooterMenu/MiniCartButtonMobile';
import WishListButtonMobileMenu from '../Components/MobileFooterMenu/WishListButtonMobileMenu';
import RegisterCustomerLink from '../Components/Register/RegisterCustomerLink';
import HeaderNavigationIconLinks from '../Components/Header/HeaderNavigationIconLinks';
import ClientContextLoader from '../Components/ClientContextLoader/ClientContextLoader';
import BackofficeLoginPage from '../Components/BackOffice/Backoffice.LoginPage';
import SiblingProductStockIcon from '../Components/ProductPageSiblingProducts/SiblingProductStockIcon';

global['Components'] = {
  ProductListing: (props) => renderWrapper(ProductListing, props),
  MiniCart: (props) => renderWrapper(MiniCart, props),
  MiniCartButton: (props) => renderWrapper(MiniCartButton, props),
  WishListButton: (props) => renderWrapper(WishListButton, props),
  WishList: (props) => renderWrapper(WishList, props),
  FavoriteButton: (props) => renderWrapper(FavoriteButton, props),
  StockStatus: (props) => renderWrapper(StockStatus, props),
  ProductFiltering: (props) => renderWrapper(ProductFiltering, props),
  ProductSorting: (props) => renderWrapper(ProductSorting, props),
  MyPagesContainer: (props) => renderWrapper(MyPagesContainer, props),
  Checkout: (props) => renderWrapper(Checkout, props),
  BuyButton: (props) => renderWrapper(BuyButton, props),
  FilterBar: (props) => renderWrapper(FilterBar, props),
  QuickSearch: (props) => renderWrapper(QuickSearch, props),
  SearchResult: (props) => renderWrapper(SearchResult, props),
  SearchNavigation: (props) => renderWrapper(SearchNavigation, props),
  ProductBlockNoSlider: (props) => renderWrapper(ProductBlockNoSlider, props),
  ProductListHeaderText: (props) => renderWrapper(ProductListHeaderText, props),
  CategoryHeaderText: (props) => renderWrapper(CategoryHeaderText, props),
  Navbar: (props) => renderWrapper(Navigation, props),
  TestContainerForReact: (props) =>
    renderWrapper(TestContainerForReact, props),
  ProductPageImageSlider: (props) =>
    renderWrapper(ProductPageImageSlider, props),
  BannerSliderBlock: (props) => renderWrapper(BannerSliderBlock, props),
  BannerBlock: (props) => renderWrapper(BannerBlock, props),
  ProductSlider: (props) => renderWrapper(ProductSlider, props),
  ActiveFilterChips: (props) => renderWrapper(ActiveFilterChips, props),
  NavigationMobileTrigger: (props) =>
    renderWrapper(NavigationMobileTrigger, props),
  NavigationMobile: (props) => renderWrapper(NavigationMobile, props),
  Overlay: (props) => renderWrapper(Overlay, props),
  VariantPickerDropdown: (props) =>
    renderWrapper(VariantPickerDropdown, props),
  VariantPickerButtons: (props) =>
    renderWrapper(VariantPickerButtons, props),
  VariantMultiPickerDropdown: (props) =>
    renderWrapper(VariantMultiPickerDropdown, props),
  LoginModal: (props) => renderWrapper(LoginModal, props),
  LoginPage: (props) => renderWrapper(LoginPage, props),
  LoginModalTrigger: (props) => renderWrapper(LoginModalTrigger, props),
  TopMessage: (props) => renderWrapper(TopMessage, props),
  OrderConfirmation: (props) => renderWrapper(OrderConfirmation, props),
  ProductsAndBannerBlock: (props) =>
    renderWrapper(ProductsAndBannerBlock, props),
  Test: (props) => renderWrapper(Test, props),
  LinkBlock: (props) => renderWrapper(LinkBlock, props),
  BrandsBlock: (props) => renderWrapper(BrandsBlock, props),
  EditorString: (props) => renderWrapper(EditorString, props),
  RichTextBlock: (props) => renderWrapper(RichTextBlock, props),
  LinkListBlock: (props) => renderWrapper(LinkListBlock, props),
  AccordionBlock: (props) => renderWrapper(AccordionBlock, props),
  Footer: (props) => renderWrapper(Footer, props),
  MegaMenuBannerBlock: (props) =>
    renderWrapper(MegaMenuBannerBlock, props),
  ProductPageUsps: (props) => renderWrapper(ProductPageUsps, props),
  SizeGuideContainer: (props) => renderWrapper(SizeGuideContainer, props),
  FaqAccordion: (props) => renderWrapper(FaqAccordion, props),
  UspBlock: (props) => renderWrapper(UspBlock, props),
  ResponsiveImage: (props) => renderWrapper(ResponsiveImage, props),
  ProductPageVariantList: (props) =>
    renderWrapper(ProductPageVariantList, props),
  ScrollToElementButton: (props) =>
    renderWrapper(ScrollToElementButton, props),
  ProductTabsContainer: (props) =>
    renderWrapper(ProductTabsContainer, props),
  ProductTabsContainerMobile: (props) =>
    renderWrapper(ProductTabsContainerMobile, props),
  ProductPageVariantIdentifier: (props) =>
    renderWrapper(ProductPageVariantIdentifier, props),
  ProductPagePrice: (props) => renderWrapper(ProductPagePrice, props),
  ProductListingTitle: (props) =>
    renderWrapper(ProductListingTitle, props),
  RegisterPage: (props) => renderWrapper(RegisterPage, props),
  CategoryNavigation: (props) => renderWrapper(CategoryNavigation, props),
  SubNavigationContainer: (props) =>
    renderWrapper(SubNavigationContainer, props),
  VariantSelectBuyButtonContainer: (props) =>
    renderWrapper(VariantSelectBuyButtonContainer, props),
  UspSign: (props) => renderWrapper(UspSign, props),
  QuickSearchLinkMobile: (props) => renderWrapper(QuickSearchLinkMobile, props),
  CustomerServiceLink: (props) => renderWrapper(CustomerServiceLink, props),
  LoginIconLink: (props) => renderWrapper(LoginIconLink, props),
  LoginIconLinkMobile: (props) => renderWrapper(LoginIconLinkMobile, props),
  LoginModalTriggerMobile: (props) =>
    renderWrapper(LoginModalTriggerMobile, props),
  MiniCartButtonMobile: (props) => renderWrapper(MiniCartButtonMobile, props),
  WishListButtonMobileMenu: (props) =>
    renderWrapper(WishListButtonMobileMenu, props),
  RegisterCustomerLink: (props) => renderWrapper(RegisterCustomerLink, props),
  HeaderNavigationIconLinks: (props) => renderWrapper(HeaderNavigationIconLinks, props),
  ClientContextLoader: () => renderWrapper(ClientContextLoader, {}),
  BackofficeLoginPage: (props) => renderWrapper(BackofficeLoginPage, props),
  SiblingProductStockIcon: (props) => renderWrapper(SiblingProductStockIcon, props),

  [GLOBAL_STYLING_COMPONENT_NAME]: () => (
    <>
      <NewsList />
      <ContentPage />
      <GlobalStyle />
    </>
  ),
};
